import {
  AppBar,
  Box,
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SendIcon from '@mui/icons-material/Send';
import ListIcon from '@mui/icons-material/FormatListBulleted';
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthGate';

const DRAWER_WIDTH = 220;

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/', icon: <DashboardIcon fontSize="small" /> },
  { label: 'Send', path: '/send', icon: <SendIcon fontSize="small" /> },
  { label: 'Browse', path: '/browse', icon: <ListIcon fontSize="small" /> },
];

export default function Layout() {
  const { clearToken } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: DRAWER_WIDTH,
            boxSizing: 'border-box',
            bgcolor: 'grey.900',
            color: 'white',
          },
        }}
      >
        <Toolbar sx={{ gap: 1 }}>
          <NotificationsActiveIcon sx={{ color: 'success.light' }} />
          <Typography variant="subtitle2" fontWeight={700} noWrap>
            Notifications
          </Typography>
        </Toolbar>

        <List dense sx={{ flex: 1 }}>
          {NAV_ITEMS.map((item) => (
            <ListItemButton
              key={item.path}
              selected={pathname === item.path}
              onClick={() => navigate(item.path)}
              sx={{
                color: 'grey.300',
                '&.Mui-selected': { bgcolor: 'grey.700', color: 'white' },
                '&:hover': { bgcolor: 'grey.800' },
                borderRadius: 1,
                mx: 0.5,
                mb: 0.5,
              }}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontSize: 13, fontWeight: pathname === item.path ? 600 : 400 }}
              />
            </ListItemButton>
          ))}
        </List>

        <Box sx={{ p: 1 }}>
          <Button
            fullWidth
            size="small"
            startIcon={<LogoutIcon fontSize="small" />}
            onClick={clearToken}
            sx={{ color: 'grey.400', textTransform: 'none', justifyContent: 'flex-start', pl: 1.5 }}
          >
            Clear token
          </Button>
        </Box>
      </Drawer>

      {/* Main area */}
      <Box component="main" sx={{ flexGrow: 1, minHeight: '100vh', bgcolor: 'grey.50' }}>
        <AppBar
          position="static"
          elevation={0}
          sx={{ bgcolor: 'white', borderBottom: '1px solid', borderColor: 'divider' }}
        >
          <Toolbar variant="dense">
            {NAV_ITEMS.find((i) => i.path === pathname) && (
              <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                {NAV_ITEMS.find((i) => i.path === pathname)?.label}
              </Typography>
            )}
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
